import "./generated/json-imports/i18n-static.js";
//# sourceMappingURL=Assets-static.js.map